import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import { create, all } from "mathjs"; // Importa Math.js
import * as Sentry from "@sentry/vue";

const math = create(all);

Vue.prototype.$math = math;

Vue.config.productionTip = false;

const dsn = process.env.VUE_APP_SENTRY_DSN ?? null;
const release = process.env.VUE_APP_SENTRY_RELEASE ?? null;
if (dsn && release) {
  Sentry.init({
    Vue,
    dsn: dsn,
    release: release,
    environment: process.env.NODE_ENV,
    initialScope: {
      tags: { component: "frontend" },
    },
  });
}

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
